/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  unref
} from 'vue';

import type {
  SupportProgress
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Public Supporters Progress
 */
export const supportersProgress = (

 signal?: AbortSignal
) => {


      return axiosClient<SupportProgress>(
      {url: `/supporters/progress`, method: 'GET', signal
    },
      );
    }




export const getSupportersProgressQueryKey = () => {
    return [
    'supporters','progress'
    ] as const;
    }


export const getSupportersProgressQueryOptions = <TData = Awaited<ReturnType<typeof supportersProgress>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportersProgress>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getSupportersProgressQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof supportersProgress>>> = ({ signal }) => supportersProgress(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof supportersProgress>>, TError, TData>
}

export type SupportersProgressQueryResult = NonNullable<Awaited<ReturnType<typeof supportersProgress>>>
export type SupportersProgressQueryError = ErrorType<unknown>


/**
 * @summary Public Supporters Progress
 */

export function useSupportersProgress<TData = Awaited<ReturnType<typeof supportersProgress>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportersProgress>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupportersProgressQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






